import React from 'react';

const HeavyCheck = () => (
  <svg
    width="22"
    height="14"
    viewBox="0 0 22 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.25781 5.17657L9.35241 11.9927L19.7578 1.99573"
      stroke="#3448FF"
      strokeWidth="4"
      strokeLinejoin="round"
    />
  </svg>
);

export default HeavyCheck;
